// Shared Error-Tracker fuer Janeway-Apps. In-Memory Ring-Buffer (100 letzte
// Fehler) plus optional Console in Dev. Kein externer Sink — Apps koennen den
// Tracker per `errorTracker.getErrors()` lesen oder eigenen Forwarder bauen.

export interface ErrorContext {
  component?: string;
  action?: string;
  userId?: string;
  metadata?: Record<string, unknown>;
}

class ErrorTracker {
  private static instance: ErrorTracker;
  private errors: Array<{ error: Error; context: ErrorContext; timestamp: string }> = [];

  static getInstance(): ErrorTracker {
    if (!ErrorTracker.instance) ErrorTracker.instance = new ErrorTracker();
    return ErrorTracker.instance;
  }

  track(error: Error | unknown, context: ErrorContext = {}): void {
    const err = error instanceof Error ? error : new Error(String(error));
    this.errors.push({ error: err, context, timestamp: new Date().toISOString() });
    if (this.errors.length > 100) this.errors.shift();
    if (process.env.NODE_ENV === "development") {
      console.error("[ErrorTracker]", err.message, context);
    }
  }

  getErrors(): Array<{ error: Error; context: ErrorContext; timestamp: string }> {
    return [...this.errors];
  }

  clear(): void {
    this.errors = [];
  }
}

export const errorTracker = ErrorTracker.getInstance();

export function trackError(error: Error | unknown, context?: ErrorContext): void {
  errorTracker.track(error, context);
}
